export default {
  path: 'dashboard',
  name: 'Dashboard',
  component: () => import('@/views/dashboard/index.vue'),
  meta: {
    title: '工作台',
    titleKey: 'routes.dashboard',
    topNav: 'dashboard',
    icon: 'DashboardOutlined',
  },
};
